import {useSyncExternalStore} from 'react'

import {getSnapshot, subscribe} from '../authTools'

/**
 * The tokens this document is holding, as something a render can depend on.
 *
 * Read straight from storage they are a value that changes without telling anyone: a session
 * cleared by a refused renewal would leave the drive drawn as though it were still signed in
 * until something unrelated happened to re-render.
 */
const useSession = () => useSyncExternalStore(subscribe, getSnapshot)

export default useSession
